import Vue from 'vue'
import Router from 'vue-router'

//框架
import layoutHeader from '@/components/layout'

Vue.use(Router);

const routes = [{
        path: '/',
        redirect: {
            name: 'index'
        },
        component: layoutHeader,
        children: [{
                path: '/login',
                name: 'login_page',
                component: () => import('@/pages/login'),
                meta: {
                    title: '登录',
                    cache: false
                }
            },
            {
                path: '/',
                name: 'index_page',
                component: () => import('@/pages/index/index2'),
                meta: {
                    title: '首页',
                    cache: false
                }
            },
            {
                path: '/questionnaire/:code',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/index'),
                meta: {
                    title: '问卷调查',
                    cache: false
                }
            },
            {
                path: '/questionnaireH5/:code',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/index_h5'),
                meta: {
                    title: '问卷调查',
                    cache: false
                }
            },
            {
                path: '/questionnaire_success',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/success'),
                meta: {
                    title: '问卷提交成功',
                    cache: false
                }
            },
            {
                path: '/questionnaireH5_success',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/success_h5'),
                meta: {
                    title: '问卷提交成功',
                    cache: false
                }
            },
            {
                path: '/questionnaire_error',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/error'),
                meta: {
                    title: '异常',
                    cache: false
                }
            },
            {
                path: '/questionnaireH5_error',
                name: 'questionnaire',
                component: () => import('@/pages/questionnaire/error_h5'),
                meta: {
                    title: '异常',
                    cache: false
                }
            },
            {
                path: '/list/:type',
                name: 'list_page',
                component: () => import('@/pages/list/list'),
                meta: {
                    title: '加载中...',
                    cache: false
                }
            },
            {
                path: '/listimg/:type',
                name: 'listimg_page',
                component: () => import('@/pages/list/listimg'),
                meta: {
                    title: '加载中...',
                    cache: false
                }
            },
            {
                path: '/list/:type/info/:code',
                name: 'info_page',
                component: () => import('@/pages/list/info'),
                meta: {
                    title: '加载中...',
                    cache: false
                }
            },
            {
                path: '/member',
                name: 'member_page',
                component: () => import('@/pages/member/index'),
                meta: {
                    title: '会员单位',
                    cache: false
                }
            },
            {
                path: '/member/join',
                name: 'member_join_page',
                component: () => import('@/pages/user/member/join'),
                meta: {
                    title: '入会申请',
                    cache: false,
                }
            },
            {
                path: '/member/list',
                name: 'member_list_page',
                component: () => import('@/pages/member/list'),
                meta: {
                    title: '会员名录',
                    cache: false,
                }
            },
            {
                path: '/zhuanti/join',
                name: 'zhuanti_join_page',
                component: () => import('@/pages/zhuanti/join'),
                meta: {
                    title: '专题申报',
                    cache: false,
                }
            },
            {
                path: '/zazhi/dingyue/:code',
                name: 'zazhi_dingyue_page',
                component: () => import('@/pages/zazhi/dingyue'),
                meta: {
                    title: '杂志订阅',
                    cache: false,
                }
            },
            {
                path: '/live',
                name: 'live_page',
                component: () => import('@/pages/live/list'),
                meta: {
                    title: '直播培训',
                    cache: false
                }
            },
            {
                path: '/live/info/:code',
                name: 'liveinfo_page',
                component: () => import('@/pages/live/info'),
                meta: {
                    title: '直播内容',
                    cache: false
                }
            },
            {
                path: '/gonggao',
                name: 'gonggao_page',
                component: () => import('@/pages/gonggao/list'),
                meta: {
                    title: '最新公告',
                    cache: false
                }
            },
            {
                path: '/gonggao/info/:code',
                name: 'gonggaoinfo_page',
                component: () => import('@/pages/gonggao/info'),
                meta: {
                    title: '公告详情',
                    cache: false
                }
            },
            {
                path: '/search',
                name: 'search_page',
                component: () => import('@/pages/list/search'),
                meta: {
                    title: '搜索页',
                    cache: false
                }
            },
            //登录会员信息
            {
                path: '/user',
                redirect: {
                    name: 'user_layout'
                },
                component: () => import('@/pages/user/layout'),
                children: [{
                        path: 'member',
                        name: 'user_member_page',
                        component: () => import('@/pages/user/member/index'),
                        meta: {
                            title: '会员详情',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'member/info/:code',
                        name: 'user_info_page',
                        component: () => import('@/pages/user/member/info'),
                        meta: {
                            title: '活动详情',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'director',
                        name: 'user_director_page',
                        component: () => import('@/pages/user/member/director'),
                        meta: {
                            title: '理事详情',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'changPassword',
                        name: 'user_changPassword_page',
                        component: () => import('@/pages/user/changPassword'),
                        meta: {
                            title: '修改密码',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'memberList',
                        name: 'user_memberList_page',
                        component: () => import('@/pages/user/member/list'),
                        meta: {
                            title: '上传资料',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'vipList',
                        name: 'user_vipList_page',
                        component: () => import('@/pages/user/member/vipList'),
                        meta: {
                            title: 'VIP资料',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'vipList/info/:code',
                        name: 'user_vipListInfo_page',
                        component: () => import('@/pages/user/message/info'),
                        meta: {
                            title: 'VIP资料详情',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'message',
                        name: 'user_message_page',
                        component: () => import('@/pages/user/message/message'),
                        meta: {
                            title: '通知消息',
                            cache: false,
                            checkLogin: true
                        }
                    },
                    {
                        path: 'message/info/:code',
                        name: 'user_messageInfo_page',
                        component: () => import('@/pages/user/message/info'),
                        meta: {
                            title: '通知详情',
                            cache: false,
                            checkLogin: true
                        }
                    },
                ]
            }

        ]
    },

]
const router = new Router({
    routes: [
        ...routes,
    ],
    mode: 'hash',
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {
                x: 0,
                y: 0
            }
        }
    }
})

export default router